export const containerByDistance = (container, targetEl, distance = 0) => {
  // 根据容器据可视窗口距离计算容器高度：可视高度 — 容器top - 底部距离
  if (!container || !targetEl) {
    return;
  }
  const diff = targetEl.getBoundingClientRect().height - container.getBoundingClientRect().top - distance;
  return diff < 0 ? 0 : diff;
};

